<template>
  <v-container fluid class="text-center">
    <v-card class="elevation-5 mt-5">
      <v-toolbar dense dark color="secondary" elevation="2">
        <v-toolbar-title> Instructores </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text small :disabled="loading || !isWriting" @click="dialogs.new = true">
          Agregar
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" :disabled="!isReading" elevation="0" color="secondary" outlined class="mx-2" @click="refresh()">
          Actualizar
          <v-icon right>mdi-refresh</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
      </v-card-title>
      <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search"
      :footer-props="{ 'items-per-page-text': 'Elementos por página', 'items-per-page-options': [20, 50, -1] }" :items-per-page="10" item-key="id" class="elevation-1" dense>
        <v-progress-linear slot="progress" color="secondary" indeterminate></v-progress-linear>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" size="22" color="primary" dark v-bind="attrs" v-on="on" :disabled="loading" @click="view(item)">mdi-pencil</v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" size="22" color="red" dark v-bind="attrs" v-on="on" :disabled="loading" @click="remove(item.instructorID)">mdi-delete</v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
        <template v-slot:footer.page-text="props"> Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }} </template>
        <template v-slot:no-data> No hay información disponible </template>
        <template v-slot:no-results> No se obtuvieron resultados </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogs.new" persistent max-width="600px">
      <v-card>
        <v-toolbar dense dark color="secondary" elevation="2">
          <v-toolbar-title>Nuevo instructor</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="cancel()">
            Cerrar
            <v-icon right>mdi-close</v-icon>
          </v-btn>
          <v-btn text small :loading="loading" :disabled="!isWriting" @click="save()">
            Guardar
            <v-icon right>mdi-check</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formNew" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="forms.new.nombre" label="Nombre" :rules="rules.nombre" :disabled="loading" required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="forms.new.apellidoPaterno" label="Apellido Paterno" :rules="rules.apellidoPaterno" :disabled="loading" required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="forms.new.apellidoMaterno" label="Apellido Materno" :rules="rules.apellidoMaterno" :disabled="loading"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="forms.new.correo" label="Correo" :rules="rules.correo" :disabled="loading"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="forms.new.telefono" label="Teléfono" :rules="rules.telefono" :disabled="loading" dense></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="forms.new.area_geografica" :items="catalogues.regiones" item-text="descripcion" item-value="lda_areaGeograficaID" label="Región" :rules="rules.area_geografica" :disabled="loading" dense persistent-hint></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="forms.new.elevateID" label="Elevate ID" :rules="rules.elevateID" :disabled="loading" dense></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.update" persistent max-width="600px">
      <v-card>
        <v-toolbar dense dark color="secondary" elevation="2">
          <v-toolbar-title>Actualizar instructor</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="cancel()">
            Cerrar
            <v-icon right>mdi-close</v-icon>
          </v-btn>
          <v-btn text small :loading="loading" :disabled="!isWriting" @click="update()">
            Actualizar
            <v-icon right>mdi-check</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formUpdate" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="forms.update.nombre" label="Nombre" :rules="rules.nombre" :disabled="loading" required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="forms.update.apellidoPaterno" label="Apellido Paterno" :rules="rules.apellidoPaterno" :disabled="loading" required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="forms.update.apellidoMaterno" label="Apellido Materno" :rules="rules.apellidoMaterno" :disabled="loading"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="forms.update.correo" label="Correo" :rules="rules.correo" :disabled="loading"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="forms.update.telefono" label="Teléfono" :rules="rules.telefono" :disabled="loading" dense></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="forms.update.area_geografica" :items="catalogues.regiones" item-text="descripcion" item-value="lda_areaGeograficaID" label="Región" :rules="rules.area_geografica" :disabled="loading" dense persistent-hint></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="forms.update.elevateID" label="Elevate ID" :rules="rules.elevateID" :disabled="loading" dense></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.remove" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Aviso</v-card-title>
        <v-card-text>¿Realmente desea eliminar el registro?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" color="blue-grey" @click="cancel()">
            Cancelar
          </v-btn>
          <v-btn text small :loading="loading" color="error" @click="remove()">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
  </v-container>
</template>

<script>
import services from "@/utils/services";

export default {
  name: "instructors",
  data: () => ({
    loading: false,
    success: false,
    msgSuccess: "",
    error: false,
    msgError: "",
    search: "",
    headers: [
      { text: "ID", align: "left", sortable: false, value: "instructorID" },
      { text: "Nombre", align: "left", sortable: false, value: "nombre_completo" },
      { text: "Correo", align: "left", sortable: false, value: "correo" },
      { text: "Teléfono", align: "left", sortable: false, value: "telefono" },
      { text: "Región", align: "left", sortable: false, value: "area_geografica.descripcion" },
      { text: "Elevate ID", align: "left", sortable: false, value: "elevateID" },
      { text: "Acciones", align: "left", sortable: false, value: "actions" },
    ],
    items: [],
    selected: [],
    catalogues: {
      regiones: []
    },
    forms: {
      new: {
        nombre: '',
        apellidoPaterno : '',
        apellidoMaterno: '',
        correo: '',
        telefono: '',
        area_geografica: '',
        elevateID: ''
      },
      update: {
        instructorID: '',
        nombre: '',
        apellidoPaterno : '',
        apellidoMaterno: '',
        correo: '',
        telefono: '',
        area_geografica: '',
        elevateID: ''
      },
    },
    rules: {
      nombre: [
        v => !!v || 'El campo es requerido',
        v => (v && v.length <= 200) || 'El campo excede la longitud máxima'
      ],
      apellidoPaterno: [
        v => !!v || 'El campo es requerido',
        v => (v && v.length <= 200) || 'El campo excede la longitud máxima'
      ],
      apellidoMaterno: [
        v => (v === '' || (v && v.length <= 200)) || 'El campo excede la longitud máxima'
      ],
      correo: [
        v => (v === '' || (v && v.length <= 100)) || 'El campo excede la longitud máxima',
        v => v === '' || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'El campo es inválido'
      ],
      telefono: [
        v => (v === '' || (v && v.length <= 15)) || 'El campo excede la longitud máxima'
      ],
      area_geografica: [
        v => !!v || 'El campo es requerido'
      ],
      elevateID: [
        v => (v === '' || (v && v.length <= 100)) || 'El campo excede la longitud máxima'
      ],
    },
    dialogs: {
      new: false,
      update: false,
      remove: false
    },
  }),
  mounted() {
    if (this.isReading) {
      this.refresh()
    }
  },
  computed: {
    isReading: function () {
      return services.check(1, this.$route.path);
    },
    isWriting: function () {
      return services.check(2, this.$route.path);
    },
    isRemoving: function() {
      return services.check(3, this.$route.path);
    }
  },
  methods: {
    async refresh() {
      this.loading = true;
      const region = await this.axios.get(services.routes.regiones)
      if (region.data.data) {
        this.catalogues.regiones = region.data.data
      }
      this.axios.get(services.routes.instructores)
        .then((response) => {
          this.items = response.data.data;
          for (let i = 0; i < this.items.length; i++) {
            this.items[i].nombre_completo = (this.items[i].nombre + " " + this.items[i].apellidoPaterno + " " + this.items[i].apellidoMaterno).trim();
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      if (this.dialogs.new) {
        this.$refs.formNew.reset()
        for (let key in this.forms.new) {
          this.forms.new[key] = ''
        }
        this.dialogs.new = false
      }
      else if (this.dialogs.update) {
        this.$refs.formUpdate.reset()
        for (let key in this.forms.update) {
          this.forms.update[key] = ''
        }
        this.dialogs.update = false
      }
      else if (this.dialogs.remove) {
        this.dialogs.remove = false
      }
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true
        let data = JSON.parse(JSON.stringify(this.forms.new))
        this.axios.post(services.routes.instructores, { data })
          .then(response => {
            this.cancel()
            this.refresh()
            this.success = true
            this.msgSuccess = 'Registro guardado exitosamente'
          })
          .catch(error => {
            this.error = true
            this.msgError = error.response.data.message || 'Servicio no disponible'
          })
          .finally(() => {
            this.loading = false
          })
      }
      else {
        this.error = true
        this.msgError = 'La información es incorrecta'
      }
    },
    view(data) {
      this.forms.update = {
        instructorID: data.instructorID,
        nombre: data.nombre,
        apellidoPaterno : data.apellidoPaterno,
        apellidoMaterno: data.apellidoMaterno,
        correo: data.correo,
        telefono: data.telefono,
        area_geografica: data.area_geografica.areaGeograficaID,
        elevateID: data.elevateID
      }
      this.dialogs.update = true
    },
    update() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true
        let data = JSON.parse(JSON.stringify(this.forms.update))
        this.axios.put(services.routes.instructores, { data })
          .then(response => {
            this.cancel()
            this.refresh()
            this.success = true
            this.msgSuccess = 'Registro actualizado exitosamente'
          })
          .catch(error => {
            this.error = true
            this.msgError = error.response.data.message || 'Servicio no disponible'
          })
          .finally(() => {
            this.loading = false
          })
      }
      else {
        this.error = true
        this.msgError = 'La información es incorrecta'
      }
    },
    remove(id) {
      if (!id) {
        this.loading = true
        this.axios.delete(services.routes.instructores, { data: { data: { instructorID: this.deleted } } })
          .then(response => {
            this.cancel()
            this.refresh()
            this.success = true
            this.msgSuccess = 'Registro eliminado exitosamente'
          })
          .catch(error => {
            this.error = true
            this.msgError = error.response.data.message || 'Servicio no disponible'
          })
          .finally(() => {
            this.loading = false
          })
      }
      else {
        this.deleted = id
        this.dialogs.remove = true
      }
    }
  },
};
</script>

<style scoped>
</style>
